import { keyframes } from '@mui/material';
export const background = keyframes`
0% {
    background-size: 200% 300%;
    background-position: 0% 0%;
  }
  25% {
    background-size: 230% 330%;
    background-position: 25% 25%;
  }
  50% {
    background-size: 200% 300%;
    background-position: 100% 0%;
  }
  75% {
    background-size: 230% 330%;
    background-position: 25% 25%;
  }
  100% {
    background-size: 200% 300%;
    background-position: 0% 0%;
  }
`;
